import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Checkbox from '@material-ui/core/Checkbox';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import ShareIcon from '@material-ui/icons/Share';


export default function SettingsDialog(props) {

  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {

   // alert(state.checkedA);
    props.handleSettingsChanged(state.Language1,state.Language2,state.Language3,state.Description1,state.Description2,state.Description3);


    setOpen(false);
  }

  const [state, setState] = React.useState({
    Language1: true,
    Language2: false,
    Language3: false,
    Description1: false,
    Description2: false,
    Description3:false
  });

  const handleChange = name => event => {
    setState({ ...state, [name]: event.target.checked });
  };



  return (
    <div>

      <IconButton aria-label="Share" onClick={handleClickOpen}>
          <ShareIcon />
        </IconButton>


      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Settings"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Edit settings
          </DialogContentText>



          <FormControlLabel
            control={
            <Checkbox checked={state.Language1} onChange={handleChange('Language1')} value="Language1" />
            }
            label="Language1"
        />

        <FormControlLabel
            control={
            <Checkbox checked={state.Language2} onChange={handleChange('Language2')} value="Language2" />
            }
            label="Language2"
        />

        <FormControlLabel
            control={
            <Checkbox checked={state.Language3} onChange={handleChange('Language3')} value="Language3" />
            }
            label="Language3"
        />

        <FormControlLabel
            control={
            <Checkbox checked={state.Description1} onChange={handleChange('Description1')} value="Description1" />
            }
            label="Description1"
        />

        <FormControlLabel
            control={
            <Checkbox checked={state.Description2} onChange={handleChange('Description2')} value="Description2" />
            }
            label="Description2"
        />

        <FormControlLabel
            control={
            <Checkbox checked={state.Description3} onChange={handleChange('Description3')} value="Description3" />
            }
            label="Description3"
        />



        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Disagree
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}